/**
 * @file [Please Input File Description]
 * @author (zhaojun10)
 */
import Pagination from './Pagination.js';
export default Pagination;